"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getInspirationContentSource;

function getInspirationContentSource() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.assetId,
      c = a.embedCode;
  return b || c ? c ? "Video Embed" : "Video" : "N/A";
}